import type { AnyAction, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { openNewRequestModal } from 'modules/requests/service';
import { translationSelector } from 'modules/translations/duck';
import { setItem as setSSItem } from 'utils/sessionStorage';
import type { RootState } from 'store/types';

import type { BannerZipcodeProps } from './BannerZipcode';
import BannerZipcode from './BannerZipcode';

const mapStateToProps = (state: RootState, props: { translationId: string }) => ({
  translation: translationSelector(state, props),
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  async openRequestModal({
    address,
    city,
    prefecture,
    cityGroupName,
    jobTypeId,
  }: {
    address?: string;
    city?: BannerZipcodeProps['city'];
    cityGroupName?: BannerZipcodeProps['cityGroupName'];
    jobTypeId?: string;
    prefecture?: BannerZipcodeProps['prefecture'];
  }) {
    await openNewRequestModal({
      context: { address, city, cityGroupName, prefecture },
      dispatch,
      properties: { initialValues: { address }, jobTypeId },
    });
    setSSItem('addressFormInput', address ?? '');
  },
});

export type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(BannerZipcode);
